import { getFormattedFloatValues } from '../../utils/number-utils';

export const noSmoothing = (points) => {
    if (!points || points.length <= 0) {
        points = [[0, 0]];
    }

    let d = 'M' + points[0][0].toFixed(4) + ',' + points[0][1].toFixed(4);
    for (let i = 1; i < points.length; i++) {
        d += 'L' + points[i][0].toFixed(4) + ',' + points[i][1].toFixed(4);
    }
    return d + 'z';
};

export const setViewBox = (options) =>
    `-${options.captionMargin} 0 ${options.size + options.captionMargin * 2} ${options.size}`;

export const defaultOptions = {
    size: 750,
    axes: true, // show axes?
    scales: 10, // show scale circles?
    captions: true, // show captions?
    dots: true, // show dots?
    zoomDistance: 1.2, // where on the axes are the captions?
    smoothing: noSmoothing, // shape smoothing function
    captionMargin: 15,
    setViewBox,
    axisProps: () => ({ className: 'axis' }),
    scaleProps: () => ({ className: 'scale', fill: 'none' }),
    shapeProps: () => ({ className: 'shape' }),
    dotProps: () => ({
        className: 'dot',
        mouseEnter: (dot) => {
            const toolTip = document.getElementById('radar-tool-tip');

            if (!toolTip) {
                return;
            }
            const formattedValue = getFormattedFloatValues(dot.value * 100);
            toolTip.innerText = `${formattedValue}%`;
            toolTip.style.visibility = 'visible';
        },
        mouseLeave: (dot) => {
            const toolTip = document.getElementById('radar-tool-tip');
            if (!toolTip) {
                return;
            }
            toolTip.innerText = '';
            toolTip.style.visibility = 'hidden';
        }
    }),
    captionProps: () => ({
        className: 'caption caption analytics-radar-caption',
        textAnchor: 'middle',
        fontSize: 12,
        fontFamily: `Nunito,-apple-system,BlinkMacSystemFont,"Segoe UI",Cardinal,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`
    })
};
